module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/tablet-6eaee42003060b6ab376b5b29a2db08b.jpg";